import { action, observable } from "mobx";

import MainEntity from "domain/main/MainEntity";

/**
 * [시스템] 배너관리 Entity
 */
export default abstract class TbSysBanEntity extends MainEntity {
  @observable protected banNo: string  = "";
  @observable protected banTpCd: string  = "";
  @observable protected stDate!: Date;
  @observable protected enDate!: Date;
  @observable protected banExpl: string  = "";
  @observable protected linkUrl: string = "";
  @observable protected newWinYn: string = "";
  @observable protected banClkCnt: number = 0;
  @observable protected banImgPath: string = "";
  @observable protected banSortSeq: number = 0;
  @observable protected banActYn: string = "";
  @observable protected fileId: string = "";
  @observable protected regUserid: string = "";
  @observable protected regDate!: Date;
  @observable protected modiUserid: string = "";
  @observable protected modiDate!: Date;

  public getBanNo() {
    return this.banNo;
  }

  @action
  public setBanNo(banNo: string): void {
    this.banNo = banNo;
  }

  public getBanTpCd() {
    return this.banTpCd;
  }

  @action
  public setBanTpCd(banTpCd: string): void {
    this.banTpCd = banTpCd;
  }

  public getStDate(): Date {
    return this.stDate;
  }

  @action
  public setStDate(stDate: Date): void {
    this.stDate = stDate;
  }

  public getEnDate(): Date {
    return this.enDate;
  }

  @action
  public setEnDate(enDate: Date): void {
    this.enDate = enDate;
  }

  public getBanExpl() {
    return this.banExpl;
  }

  @action
  public setBanExpl(banExpl: string): void {
    this.banExpl = banExpl;
  }

  public getLinkUrl() {
    return this.linkUrl;
  }

  @action
  public setLinkUrl(linkUrl: string): void {
    this.linkUrl = linkUrl;
  }

  public getNewWinYn() {
    return this.newWinYn;
  }

  @action
  public setNewWinYn(newWinYn: string): void {
    this.newWinYn = newWinYn;
  }

  public getBanClkCnt(): number {
    return this.banClkCnt;
  }

  @action
  public setBanClkCnt(banClkCnt: number): void {
    this.banClkCnt = banClkCnt;
  }

  public getBanImgPath() {
    return this.banImgPath;
  }

  @action
  public setBanImgPath(banImgPath: string): void {
    this.banImgPath = banImgPath;
  }

  public getBanSortSeq(): number {
    return this.banSortSeq;
  }

  @action
  public setBanSortSeq(banSortSeq: number): void {
    this.banSortSeq = banSortSeq;
  }

  public getBanActYn() {
    return this.banActYn;
  }

  @action
  public setBanActYn(banActYn: string): void {
    this.banActYn = banActYn;
  }

  public getFileId() {
    return this.fileId;
  }

  @action
  public setFileId(fileId: string): void {
    this.fileId = fileId;
  }

  public getRegUserid() {
    return this.regUserid;
  }

  @action
  public setRegUserid(regUserid: string): void {
    this.regUserid = regUserid;
  }

  public getRegDate(): Date {
    return this.regDate;
  }

  @action
  public setRegDate(regDate: Date): void {
    this.regDate = regDate;
  }

  public getModiUserid() {
    return this.modiUserid;
  }

  @action
  public setModiUserid(modiUserid: string): void {
    this.modiUserid = modiUserid;
  }

  public getModiDate(): Date {
    return this.modiDate;
  }

  @action
  public setModiDate(modiDate: Date): void {
    this.modiDate = modiDate;
  }
}
